module.exports = __webpack_public_path__ + "img/ref_no.99f21903.svg";